module.exports = __webpack_public_path__ + "images/icon-arrowdown_35bd561a8966e3097df31a73243fee3d.png";